import CoinStack from '@/assets/icons/CoinStack.svg';
import { HelpTip } from '@/components/HelpTip';
import * as Styled from './LoyaltyPoints.styled';

interface LoyaltyPointsProps {
  points: number;
}

export const LoyaltyPoints = ({ points }: LoyaltyPointsProps) => (
  <Styled.Container>
    <CoinStack aria-hidden="true" />
    <p>Collect {points} Reward Points</p>
    <HelpTip
      label="Help with loyalty points"
      tip="Earn 3 Rewards Points per €1 spent"
      variant="help"
    />
  </Styled.Container>
);
